import { z } from "zod";
// ============ Payload Schema ============
/**
 * Payload stored in EmploymentInvitation.payload JSON field
 */
export const EmploymentInvitationPayloadSchema = z.object({
    email: z.string().email(),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    phone: z.string().optional(),
    jobRoleId: z.string().uuid().optional(),
    locationId: z.string().uuid().optional(),
    compensation: z
        .object({
        type: z.enum(["HOURLY", "SALARY"]),
        amount: z.number().positive(),
    })
        .optional(),
    userId: z.string().uuid(),
    employmentId: z.string().uuid(),
    isNewUser: z.boolean(),
    isMobileUser: z.boolean().default(false),
});
// ============ Input Schemas ============
/**
 * Create invitation input (from admin)
 */
export const CreateEmploymentInvitationInputSchema = z.object({
    email: z.string().email(),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    phone: z.string().optional(),
    jobRoleId: z.string().uuid().optional(),
    locationId: z.string().uuid().optional(),
    compensation: z
        .object({
        type: z.enum(["HOURLY", "SALARY"]),
        amount: z.number().positive(),
    })
        .optional(),
});
/**
 * Verify OTP input
 */
export const VerifyOtpInputSchema = z.object({
    otp: z.string().length(6),
});
/**
 * Complete signup input
 */
export const CompleteSignupInputSchema = z.object({
    completionToken: z.string(),
    password: z
        .string()
        .min(8)
        .regex(/[A-Z]/, "Must contain an uppercase letter")
        .regex(/[a-z]/, "Must contain a lowercase letter")
        .regex(/[0-9]/, "Must contain a number")
        .optional(),
    phone: z.string().optional(),
});
// ============ Response Schemas ============
/**
 * Response after creating invitation (includes plaintext OTP and magic link)
 */
export const EmploymentInvitationResponseSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    firstName: z.string(),
    lastName: z.string(),
    otp: z.string().length(6),
    magicLink: z.string(),
    expiresAt: z.string().datetime(),
    createdAt: z.string().datetime(),
    sentAt: z.string().datetime().nullable(),
});
/**
 * Response after verifying OTP or magic link
 */
export const VerifyResponseSchema = z.object({
    completionToken: z.string(),
    invitation: z.object({
        id: z.string().uuid(),
        email: z.string().email(),
        firstName: z.string(),
        lastName: z.string(),
        isNewUser: z.boolean(),
    }),
});
/**
 * Response after completing signup
 */
export const CompleteSignupResponseSchema = z.object({
    user: z.object({
        id: z.string().uuid(),
        email: z.string().email(),
        firstName: z.string(),
        lastName: z.string(),
    }),
    employment: z.object({
        id: z.string().uuid(),
        companyId: z.string().uuid(),
        activatedAt: z.string().datetime(),
    }),
    accessToken: z.string(),
    refreshToken: z.string(),
});
/**
 * List response
 */
export const EmploymentInvitationListItemSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    firstName: z.string(),
    lastName: z.string(),
    status: z.enum(["PENDING", "USED", "EXPIRED"]),
    expiresAt: z.string().datetime(),
    createdAt: z.string().datetime(),
    usedAt: z.string().datetime().nullable(),
    sentAt: z.string().datetime().nullable(),
});
